



























import { Component, Vue, Watch } from 'vue-property-decorator'
import NotificationService from '@/services/NotificationService'
import { likeNotificationRef } from '@/firebase'
import { getLikeCount } from '@/helpers/GetNotificationCount'
import LikeNotificationCommon from '@/components/LikeNotification.vue'
import { hanldeUserStatus } from '@/helpers/Common'
@Component({
  components: {
    LikeNotificationCommon
  }
})
export default class LikeList extends Vue {
  notifications: any[] = []
  private limit = this.$store.state.setting.setting.setting_display
    .number_item_lists
  page: number = 1
  maxPage: number = Math.ceil(100 / this.limit)
  isLoading: boolean = true
  isLoadingLoadMore: boolean = false
  private unsubscribe: any

  async created() {
    this.getNotification()
    getLikeCount()

    // firebase get change unread notification
    this.handleRealtime()
  }

  destroyed() {
    this.unsubscribe()
  }

  @Watch('$store.state.userInfo.user.info.id')
  handleRealtime() {
    let trackingRealtime = true
    const userId = this.$store.state.userInfo.user.info.id
    if (!userId) return
    const start = this.moment()
      .subtract(1, 'm')
      .toDate()
    this.unsubscribe = likeNotificationRef
      .where('userIds', 'array-contains', userId)
      .where('createdAt', '>', start)
      .onSnapshot((querySnapshot: any) => {
        if (trackingRealtime) {
          trackingRealtime = false
        } else {
          this.getNotification()
          getLikeCount()
        }
      })
  }

  getNotification() {
    if (this.limit > 100) this.limit = 100

    NotificationService.getNotificationLike(this.limit, this.page)
      .then(res => {
        if (res.status === 200) {
          const mappingData = res.data.data.map((item: any) => ({
            ...item,
            isTranslated: false,
            translatedText: ''
          }))
          this.notifications = [...this.notifications, ...mappingData]

          //set max is 100 items
          if (this.notifications.length > 100) {
            this.notifications = this.notifications.slice(0, 100)
          }

          //set max page
          this.maxPage =
            res.data.meta.pagination.total_pages < this.maxPage
              ? res.data.meta.pagination.total_pages
              : this.maxPage
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        this.isLoading = false
        this.isLoadingLoadMore = false
      })
  }

  loadMoreNotification() {
    if (this.page >= this.maxPage) return
    this.page++
    this.isLoadingLoadMore = true
    this.getNotification()
  }

  goToLike() {
    if (this.$route.name === 'like') {
      this.$emit('hideDropdownLike')
    } else {
      this.$router.push({ name: 'like' })
    }
  }

  handleGetUserNameLike(notification: any) {
    let userLikeName =
      notification.allow_like_anonymous === true
        ? (notification.update_by_user as any[])
            .map(() => this.$t('common.suffix.anonymous') as string)
            .join(this.$t('common.suffix.comma') as string)
        : (notification.update_by_user.map((item: any) => {
            if (item.user_active_status) {
              return `<span class='text-secondary-tint-less'>${hanldeUserStatus(
                item.name,
                item.user_active_status
              )}</span>`
            }
            return hanldeUserStatus(item.name, item.user_active_status)
          }) as any[])
            .map((item: any) => item + (this.$t('common.suffix.san') as string))
            .join(this.$t('common.suffix.comma') as string)

    return userLikeName
  }
}
